import { PersonRequest } from "@plinknz/tah-website-elements";

import { researchConfig } from "./config-generics/alignment";
import { bankConfig } from "./config-generics/bank-details";
import { feesConfig, tertiaryInstitutionConfig } from "./config-generics/institution";
import { mahiConfig } from "./config-generics/employment";
import { personalDetailsConfig } from "./config-generics/personal-details";
import { scholarshipGuidelinesConfig } from "./config-generics/scholarship-guidelines";
import { signatureConfig } from "./config-generics/signature";

export const createSurveyConfig = (member: PersonRequest) => {
    const personalConfig = personalDetailsConfig(member);
    const tertiaryDetailsConfig = tertiaryInstitutionConfig({ schoolQuals: true});
    const guidelines = scholarshipGuidelinesConfig({ project: true });
    const feesDetailsConfig = feesConfig({});

    const pages = [
        ...guidelines,
        ...personalConfig,
        ...bankConfig,
        ...tertiaryDetailsConfig,
        ...researchConfig,
        ...feesDetailsConfig,
        ...mahiConfig,
        ...signatureConfig,
    ];
    
    return { pages };
};